import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router'

import { Loader } from '@/components/loaders/Loader'
import './CallSearchProxy.scss'

export const CallSearchProxy = () => {
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    history.push(`/explorer${location.search}`)
  })

  return (
    <div data-testid="call-search-proxy" className="call-search-proxy__container">
      <Loader size="large" className="call-search-proxy__loader" />
      <div data-testid="backup-text" className="call-search-proxy__backup-text">
        Redirecting to the Call Explorer. If you are not redirected within a few seconds, click{' '}
        <a data-testid="backup-link" href={`/explorer${location.search}`}>
          here
        </a>
      </div>
    </div>
  )
}

export default CallSearchProxy
